import { render, staticRenderFns } from "./r-task-config-table.vue?vue&type=template&id=8f7e6f0c"
import script from "./r-task-config-table.vue?vue&type=script&lang=js"
export * from "./r-task-config-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f7e6f0c')) {
      api.createRecord('8f7e6f0c', component.options)
    } else {
      api.reload('8f7e6f0c', component.options)
    }
    module.hot.accept("./r-task-config-table.vue?vue&type=template&id=8f7e6f0c", function () {
      api.rerender('8f7e6f0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/worker/r-task-config-table.vue"
export default component.exports